/**
 * Switch component type definitions
 */

export enum SwitchSize {
  Small = 'sm',
  Default = 'default',
  Large = 'lg',
}

export enum SwitchVariant {
  Default = 'default',
  Success = 'success',
  Destructive = 'destructive',
}
